module.exports = __webpack_public_path__ + "img/placeholder.cfc4da78.png";